import { ResponsiveRouteGuard } from './responsive-route-guard';
import { MobileContainerComponent } from './mobile-container/mobile-container.component';
import { LandingComponent } from './landing/landing.component';
import { RoomDetailComponent } from './room-detail/room-detail.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent} from './home/home.component';
import { RoomsComponent} from './rooms/rooms.component';
import { LocationComponent} from './location/location.component';
import { ContactComponent} from './contact/contact.component';

const routes: Routes = [
  { path: 'landing', component: LandingComponent, canActivate: [ResponsiveRouteGuard]},
  { path: 'home', component: HomeComponent, canActivate: [ResponsiveRouteGuard]},
  { path: 'contact', component: ContactComponent, canActivate: [ResponsiveRouteGuard]},
  { path: 'rooms', component: RoomsComponent , canActivate: [ResponsiveRouteGuard]},
  { path: 'location', component: LocationComponent, canActivate: [ResponsiveRouteGuard]},
  { path: 'contact', component: ContactComponent, canActivate: [ResponsiveRouteGuard]},
  { path: 'room-detail/:id', component: RoomDetailComponent , canActivate: [ResponsiveRouteGuard]},
  { path: 'mobile', component: MobileContainerComponent },
  { path: '**', component: LandingComponent, pathMatch: 'full' , canActivate: [ResponsiveRouteGuard]}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
